export const listConversations = /* GraphQL */ `
  query ListConversations($limit: Int, $nextToken: String, $cognitoIdentityId: String) {
    listConversations(limit: $limit, nextToken: $nextToken, cognitoIdentityId: $cognitoIdentityId) {
      conversations {
        conversationId
        title
        createdAt
        updatedAt
        messages {
          messageId
          role
          content
          timestamp
        }
      }
      nextToken
    }
  }
`;

export const createConversation = /* GraphQL */ `
  mutation CreateConversation($title: String) {
    createConversation(title: $title) {
      conversationId
      title
      createdAt
      updatedAt
      messages {
        messageId
        role
        content
        timestamp
      }
    }
  }
`;

export const chatWithMeetings = /* GraphQL */ `
  query ChatWithMeetings($query: String!, $conversationId: String, $cognitoIdentityId: String) {
    chatWithMeetings(query: $query, conversationId: $conversationId, cognitoIdentityId: $cognitoIdentityId) {
      answer
      sources {
        content
        metadata
      }
      conversationId
      messageId
    }
  }
`;


export const getConversation = /* GraphQL */ `
  query GetConversation($conversationId: String!, $cognitoIdentityId: String) {
    getConversation(conversationId: $conversationId, cognitoIdentityId: $cognitoIdentityId) {
      conversationId
      title
      createdAt
      updatedAt
      messages {
        messageId
        role
        content
        timestamp
        sources {
          content
          metadata
        }
      }
    }
  }
`;

export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation($conversationId: String!, $cognitoIdentityId: String) {
    deleteConversation(conversationId: $conversationId, cognitoIdentityId: $cognitoIdentityId) {
      success
    }
  }
`;

export const onChatResponse = /* GraphQL */ `
  subscription OnChatResponse($conversationId: String!) {
    onChatResponse(conversationId: $conversationId) {
      conversationId
      messageId
      answer
      status
      sources {
        content
        metadata
      }
    }
  }
`;

